export const ERROR_ACTION = 'error';
export const ERROR_ACTION_SUBJECT = 'growth-experiment';

export const CONFLUENCE_OPERATIONAL_EVENT_TYPE = 'sendOperationalEvent';

export const EVENT_CHANNEL_GROWTH_ERROR_ANALYTICS = 'growth-error-analytics';

export enum Product {
	JIRA = 'jira',
	CONFLUENCE = 'confluence',
	ADMIN_HUB = 'admin-hub',
}

export enum ErrorType {
	GRAPHQL = 'graphql',
	REST = 'rest',
	ERROR_BOUNDARY = 'error-boundary',
	GENERIC = 'generic',
}

export enum Severity {
	LOW = 'low',
	MEDIUM = 'medium',
	HIGH = 'high',
}

export const EVENT_TAG_GROWTH = 'growth';
